export default {"src":"/_next/static/media/AMCX.07869fb1.svg","height":18,"width":18};